export const DEMO_MENU_ITEMS = [
  {
    menuResponse:
      'NACHOS, LOS QUE NO SON TAN MEXICANOS PERO TODO MUNDO CREE QUE SÍ. TOTOPOS CON QUESO GRATINADO, GUACAMOLE, PICO DE GALLO, CREMA AGRIA Y JALAPEÑO.',
    menuSearchQuery: 'Nachos',
    nutritional_score: 3,
    description: 'Crispy tortilla chips topped with melted cheese, guacamole, pico de gallo, sour cream and jalapeños.',
    approximate_calories: 600,
    price: 12.5,
    nutritional_summary: 'High in fats and carbohydrates, moderate protein.',
    is_vegetarian: true,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    // Allergen information
    cereals_containing_gluten: 'low',
    crustaceans: 'low',
    eggs: 'low',
    fish: 'low',
    peanuts: 'low',
    soybeans: 'low',
    milk: 'low',
    nuts: 'low',
    celery: 'low',
    mustard: 'low',
    sesame_seeds: 'low',
    sulphur_dioxide_and_sulphites: 'high',
    lupin: 'low',
    molluscs: 'low',
    imageUrls: [
      'http://media2.s-nbcnews.com/i/streams/2014/November/141105/1D274907154303-today-nachos-141105.jpg',
      'https://www.sogoodblog.com/wp-content/uploads/2014/02/super-nachos-recipe.jpg',
      'https://foodiewish.com/wp-content/uploads/2021/12/vegetarian-nachos-with-guacamole-86796-1-scaled.jpeg',
    ],
  },
  {
    menuResponse:
      'La insuperable Cochinita Pibil. CERDO MARINADO 48 HORAS EN NUESTRO ADOBO ESTRELLA, HORNEADO EN HOJA DE PLÁTANO DURANTE 12 HORAS A BAJA TEMPERATURA, SERVIDO DESHEBRADO SOBRE TORTILLA DE MAÍZ, ACOMPAÑADO DE CEBOLLA MORADA ENCURTIDA.',
    menuSearchQuery: 'Cochinita Pibil',
    nutritional_score: 4,
    approximate_calories: 700,
    price: 18.95,
    nutritional_summary: 'Rich in protein and fats, moderate carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    // Allergen information
    cereals_containing_gluten: 'low',
    crustaceans: 'low',
    eggs: 'low',
    fish: 'low',
    peanuts: 'low',
    soybeans: 'low',
    milk: 'low',
    nuts: 'low',
    celery: 'low',
    mustard: 'low',
    sesame_seeds: 'low',
    sulphur_dioxide_and_sulphites: 'high',
    lupin: 'low',
    molluscs: 'low',
    imageUrls: [
      'https://www.allrecipes.com/thmb/TnQ8XgFbZMlRjcPh04ixTdshOFE=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/4919182-8d9d75b698ee4dae93b0b5ecbb639441.jpg',
      'https://d36tnp772eyphs.cloudfront.net/blogs/1/2019/04/Cochinita-pibil.jpg',
      'https://www.funsunmexico.com/blog/wp-content/uploads/Cochinita-Pibil.jpg',
    ],
  },
  {
    menuResponse:
      'Tacos de Pollo al Pibil. LA OPCIÓN LIGERA DE LA COCHINITA ELABORADO CON POLLO. SERVIDO DESHEBRADO SOBRE TORTILLA DE MAÍZ ACOMPAÑADO DE CEBOLLA MORADA ENCURTIDA.',
    menuSearchQuery: 'Tacos de Pollo al Pibil',
    nutritional_score: 5,
    approximate_calories: 500,
    price: 14.75,
    nutritional_summary: 'Moderate in protein and fats, low carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    // Allergen information
    cereals_containing_gluten: 'low',
    crustaceans: 'low',
    eggs: 'low',
    fish: 'low',
    peanuts: 'low',
    soybeans: 'low',
    milk: 'low',
    nuts: 'low',
    celery: 'low',
    mustard: 'low',
    sesame_seeds: 'low',
    sulphur_dioxide_and_sulphites: 'high',
    lupin: 'low',
    molluscs: 'low',
    imageUrls: [
      'https://www.muydelish.com/wp-content/uploads/2021/04/Cochinita-pibil.jpg',
      'https://inmamamaggieskitchen.com/wp-content/uploads/2019/07/Pollo-Pibil-Taco.jpg',
      'https://inmamamaggieskitchen.com/wp-content/uploads/2019/07/Pollo-Pibil-.jpg',
    ],
  },
  {
    menuResponse:
      'Flautas de patata e pollo. TACOS FRITOS RELLENOS. ACOMPAÑADOS DE GUACAMOLE, CREMA AGRIA, LECHUGA Y QUESO FRESCO. ELIGE EL RELLENO DE POLLO O VEGETARIANO DE PATATA.',
    menuSearchQuery: 'Flautas de patata e pollo',
    nutritional_score: 2,
    approximate_calories: 650,
    price: 16.25,
    nutritional_summary: 'High in fats and carbohydrates, moderate protein.',
    is_vegetarian: null,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'medium',
    cholesterol: 'medium',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'high',
    fiber: 'medium',
    protein: 'medium',
    purines: null,
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://www.theanthonykitchen.com/wp-content/uploads/2019/06/Chicken-Flautas-1.jpg',
      'https://sabrosano.com/wp-content/uploads/2023/04/Flautas-de-Pollo-con-Papa-Foto-Cuadrada.jpg',
      'https://milrecetas.net/wp-content/uploads/2017/09/Flautas-de-pollo-2.jpg',
    ],
  },
  {
    menuResponse: 'Taco del Mar estilo Baja. TORTILLA DE MAÍZ, MERLUZA REBOZADA, PICO DE GALLO Y MAYONESA DE CHIPOTLE.',
    menuSearchQuery: 'Taco del Mar estilo Baja',
    nutritional_score: 4,
    approximate_calories: 450,
    price: 9.95,
    nutritional_summary: 'Moderate in protein and fats, low carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: false,
    trans_fat: 'low',
    cholesterol: 'medium',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'low',
    fiber: 'low',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'medium',
    folate: 'low',
    imageUrls: [
      'https://cdn7.kiwilimon.com/recetaimagen/36709/45770.jpg',
      'https://mysliceofmexico.files.wordpress.com/2020/03/000-fish-tacos-baja-style-my-slice-of-mexico.jpg',
      'https://tacodelmar.com/wp-content/uploads/2021/02/Fish-Tacos_2-small.png',
    ],
  },
  {
    menuResponse:
      'Quesadillas/Sincronizadas. TORTILLA DE TRIGO (O MAÍZ) RELLENAS DE JAMÓN Y QUESO. ACOMPAÑADAS DE PICO DE GALLO.',
    menuSearchQuery: 'Quesadillas',
    nutritional_score: 3,
    approximate_calories: 550,
    nutritional_summary: 'High in fats and carbohydrates, moderate protein.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'medium',
    cholesterol: 'medium',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'high',
    fiber: 'low',
    protein: 'medium',
    purines: null,
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://cdn.momsdish.com/wp-content/uploads/2021/04/Chicken-Quesadillas012-2048x3072.jpg',
      'https://valentinascorner.com/wp-content/uploads/2021/04/Cheese-Quesadilla-1-760x1140.jpg',
      'https://1.bp.blogspot.com/-zzZRc0G5Q5g/VQ1z3hUiVII/AAAAAAAABJY/srJ_yo3Lk9Y/s1600/IMG_3378.JPG',
    ],
  },
  {
    menuResponse:
      'Taco Poblano. DELICIOSO GUISADO DE RAJAS POBLANAS (PIMIENTO VERDE), CEBOLLITA Y MAÍZ DULCE. EN TORTILLA DE MAÍZ Y ACOMPAÑADOS DE GUACAMOLE.',
    menuSearchQuery: 'Taco Poblano',
    nutritional_score: 5,
    approximate_calories: 400,
    nutritional_summary: 'Moderate in carbohydrates and fats, low protein.',
    is_vegetarian: true,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'low',
    cholesterol: 'low',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'medium',
    protein: 'low',
    purines: null,
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'medium',
    folate: 'medium',
    imageUrls: [
      'https://1.bp.blogspot.com/-idNHct8BA2c/V-GDEAyDzjI/AAAAAAAAKiA/5XpFWBqma9gJ5AcHJnveJFQEBo5Xzr82QCLcB/s1600/rajas%2Bcon%2Bqueso%2B3A.jpg',
      'https://i.pinimg.com/originals/29/85/9d/29859dda865ec4c7879fca6c3b72da94.jpg',
      'https://media.blueapron.com/recipes/2922/square_newsletter_images/1523483874-1-0009-0337/0514_2PV2_Tacos_5555_WEB_SQ_hi_res.jpg',
    ],
  },
  {
    menuResponse: 'Tostada de atún. TORTILLA DE MAÍZ CRUJIENTE, CAMA DE GUACAMOLE, ATÚN Y SÉSAMO.',
    menuSearchQuery: 'Tostada de atún',
    nutritional_score: 5,
    approximate_calories: 350,
    nutritional_summary: 'High in protein, moderate fats, low carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'low',
    cholesterol: 'medium',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'low',
    fiber: 'medium',
    protein: 'high',
    purines: 'high',
    oxalates: null,
    potassium: 'high',
    calcium: 'low',
    iron: 'medium',
    folate: 'low',
    imageUrls: [
      'https://cdn0.recetasgratis.net/es/posts/4/9/4/tostadas_de_atun_mexicanas_75494_orig.jpg',
      'https://www.elcomal.com/wp-content/uploads/2022/08/Salpicon-Tostadas-1-2000x1335.jpg',
      'https://i.pinimg.com/originals/38/f4/57/38f45761fbd4d89925f6d2f6ef641e55.jpg',
    ],
  },
  {
    menuResponse:
      'La Birrita de la Güerita. TERNERA GUISADA EN ADOBO DE CHILES, SERVIDA EN TACOS O QUESADILLAS ACOMPAÑADA DE CONSOME, CEBOLLA Y CILANTRO.',
    menuSearchQuery: 'La Birrita de la Güerita',
    nutritional_score: 5,
    approximate_calories: 600,
    nutritional_summary: 'High in protein and fats, moderate carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'medium',
    cholesterol: 'high',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'low',
    protein: 'high',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'medium',
    folate: 'low',
    imageUrls: [
      'https://mir-s3-cdn-cf.behance.net/project_modules/fs/cfb6b7115319533.604bde7be5351.jpg',
      'https://img.restaurantguru.com/cecf-Restaurant-Birria-De-Res-Estilo-Sinaloa-La-Guerita-food.jpg',
      'https://i.pinimg.com/originals/40/b4/af/40b4afa5e1af6d0f53e5ea12b687b89b.png',
    ],
  },
  {
    menuResponse:
      'Tacos al Pastor. AUTÉNTICO TACO DE CERDO ADOBADO, CORTADO DIRECTAMENTE DEL TROMPO, SOBRE TORTILLA DE MAÍZ, ACOMPAÑADO DE PIÑA, CILANTRO Y CEBOLLA.',
    menuSearchQuery: 'Tacos al Pastor',
    nutritional_score: 5,
    approximate_calories: 500,
    nutritional_summary: 'Moderate in protein and fats, low carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'low',
    cholesterol: 'medium',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'low',
    fiber: 'low',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'medium',
    folate: 'low',
    imageUrls: [
      'https://www.jocooks.com/wp-content/uploads/2022/04/tacos-al-pastor-feature-1.jpg',
      'http://milrecetas.net/wp-content/uploads/2016/09/Tacos-al-pastor-3.jpg',
      'https://www.culinaryhill.com/wp-content/uploads/2022/12/Tacos-al-Pastor-Culinary-Hill-1200x800-1.jpg',
    ],
  },
  {
    menuResponse: 'Gringa al Pastor. DOS TORTILLAS DE TRIGO RELLENAS DE CARNE AL PASTOR Y QUESO FUNDIDO.',
    menuSearchQuery: 'Gringa al Pastor',
    nutritional_score: 4,
    approximate_calories: 650,
    nutritional_summary: 'High in fats and carbohydrates, moderate protein.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'medium',
    cholesterol: 'medium',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'high',
    fiber: 'low',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://productoschata.com/wp-content/uploads/elementor/thumbs/Gringa-Pastor_H1-q7vbnz0ehweut9hmqzqbrl5jrolruukrhmgh1u9g8g.jpg',
      'https://www.gastrolabweb.com/u/fotografias/m/2021/5/15/f1280x720-13288_144963_5050.jpeg',
      'https://www.cocinavital.mx/wp-content/uploads/2017/09/gringa-al-pastor115.jpg',
    ],
  },
  {
    menuResponse: 'Torta al Pastor. BOCADILLO DE CARNE AL PASTOR, CON FRIJOLES, QUESO, CILANTRO, CEBOLLA Y PIÑA.',
    menuSearchQuery: 'Torta al Pastor',
    nutritional_score: 4,
    approximate_calories: 700,
    nutritional_summary: 'High in carbohydrates and fats, moderate protein.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'medium',
    cholesterol: 'medium',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'high',
    fiber: 'medium',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://storage.googleapis.com/dam-bks-prd-1385851.bks.prd.v8.commerce.mi9cloud.com/Images/Recipes/Grilled-Torta-al-Pastor-600x360.webp',
      'https://www.sargento.com/assets/Uploads/Recipe/Image/torta-v2__FillWzExNzAsNTgzXQ.jpg',
      'https://thumbs.dreamstime.com/z/mexican-food-pork-sandwich-also-known-as-torta-al-pastor-mexican-food-pork-sandwich-also-known-as-torta-al-pastor-wooden-185828030.jpg',
    ],
  },
  {
    menuResponse:
      'El tace Moreno de Pastor. TACO DE PASTOR CON TORTILLA DE MAÍZ EN UNA CAMA DE QUESO Y FRIJOLES CON CEBOLLA, CILANTRO Y PIÑA.',
    menuSearchQuery: 'El tace Moreno de Pastor',
    nutritional_score: 5,
    approximate_calories: 550,
    nutritional_summary: 'Moderate in protein and fats, low carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: false,
    trans_fat: 'low',
    cholesterol: 'medium',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'low',
    fiber: 'medium',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://www.mexicodesconocido.com.mx/wp-content/uploads/2019/08/4.jpg',
      'https://www.mexicodesconocido.com.mx/wp-content/uploads/2019/08/6-1000x750.jpg',
      'https://www.mexicodesconocido.com.mx/wp-content/uploads/2019/03/taco_al_pastor_historia_el_mejor_platillo_comida-768x512.jpg',
    ],
  },
  {
    menuResponse:
      'Chilaquiles estilo La Güerita. TOTOPOS BAÑADOS CON LOS FRIJOLES DE LA ABUELA, CARNE AL PASTOR Y QUESO GRATINADO CON CEBOLLA, CREMA AGRIA, CILANTRO Y PIÑA.',
    menuSearchQuery: 'Chilaquiles estilo La Güerita',
    nutritional_score: 4,
    approximate_calories: 750,
    nutritional_summary: 'High in fats and carbohydrates, moderate protein.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'medium',
    cholesterol: 'medium',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'high',
    fiber: 'medium',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://www.tripsavvy.com/thmb/vY9kLj21bCf2ffoy-Kb39ime9Ng=/4032x3024/filters:fill(auto,1)/breakfast-737876157-5b609960c9e77c002512e6be.jpg',
      'https://images.squarespace-cdn.com/content/v1/5e3b43e98166335a98b875b8/1629956253579-P31HHA1X71Q5UJZS9YWU/ChilaquilesVerdes.jpeg',
      'https://www.acouplefortheroad.com/wp-content/uploads/2020/06/Depositphotos_209953730_l-2015.jpg',
    ],
  },
  {
    menuResponse:
      'Tacos de Berenjena al Pastor. LA OPCIÓN VEGANA CON NUESTRO DELICIOSO ALIÑO DE PASTOR SERVIDA EN TORTILLA DE MAÍZ ACOMPAÑADO DE CEBOLLA, CILANTRO Y PIÑA.',
    menuSearchQuery: 'Tacos de Berenjena al Pastor',
    nutritional_score: 7,
    approximate_calories: 350,
    nutritional_summary: 'Low in fats, moderate carbohydrates, low protein.',
    is_vegetarian: true,
    is_vegan: true,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'low',
    cholesterol: 'low',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'medium',
    protein: 'low',
    purines: 'low',
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'medium',
    folate: 'medium',
    imageUrls: [
      'https://grillinwithdad.com/wp-content/uploads/2019/09/al-pastor-taco.jpeg',
      'https://www.jocooks.com/wp-content/uploads/2022/04/tacos-al-pastor-feature-1.jpg',
      'https://www.mdzol.com/u/fotografias/m/2023/4/8/f768x1-1392215_1392342_15.jpg',
    ],
  },
  {
    menuResponse: 'Esquites de maíz dulce. GRANO DE MAÍZ CON MANTEQUILLA, MAYONESA, CHIPOTLE, QUESO FRESCO Y TOTOPOS.',
    menuSearchQuery: 'Esquites de maíz dulce',
    nutritional_score: 5,
    approximate_calories: 400,
    nutritional_summary: 'Moderate in fats and carbohydrates, low protein.',
    is_vegetarian: true,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'low',
    cholesterol: 'medium',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'medium',
    protein: 'low',
    purines: null,
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://www.lacostena.com.mx/media/thumbnail/uploads/Recipes/botana/esquites.jpg.1920x800_q85_center.jpg',
      'https://www.mylatinatable.com/wp-content/uploads/2019/07/Esquites-1.jpg',
      'https://mmmole.com/wp-content/uploads/2021/06/esquites-19-1030x682.jpg',
    ],
  },
  {
    menuResponse:
      'Frijoles refritos con totopos. ALUBIAS NEGRAS MEXICANAS TRITURADAS ESPOLVOREADAS DE QUESO FRESCO. ACOMPAÑADO DE TOTOPOS.',
    menuSearchQuery: 'Frijoles refritos con totopos',
    nutritional_score: 6,
    approximate_calories: 450,
    nutritional_summary: 'Moderate in protein and carbohydrates, low fats.',
    is_vegetarian: true,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'low',
    cholesterol: 'low',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'high',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'high',
    calcium: 'medium',
    iron: 'medium',
    folate: 'medium',
    imageUrls: [
      'https://i.pinimg.com/originals/48/73/a8/4873a88ab43f278a22ddaed8994e1955.jpg',
      'https://www.senorcactus.com.mx/wp-content/uploads/2022/09/FRIJOLES-REFRITOS-CON-TOTOPOS_01.jpg',
      'https://thumbs.dreamstime.com/b/frijol-frito-mexicano-con-queso-y-totopos-frijoles-fritos-tradicionales-mexicanos-238837731.jpg',
    ],
  },
  {
    menuResponse:
      'Pico de gallo con totopos. MEZCLA DE TOMATE, CEBOLLA, AGUACATE Y CILANTRO, CON NUESTRO ALIÑO ESPECIAL. ACOMPAÑADO DE TOTOPOS.',
    menuSearchQuery: 'Pico de gallo con totopos',
    nutritional_score: 7,
    approximate_calories: 300,
    nutritional_summary: 'Low in fats, moderate carbohydrates, low protein.',
    is_vegetarian: true,
    is_vegan: true,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'low',
    cholesterol: 'low',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'medium',
    protein: 'low',
    purines: 'low',
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'low',
    folate: 'medium',
    imageUrls: [],
  },
];
